import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Chi tiết bộ phận")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "las la-reply",
  style: {"font-size":"1.5em"}
}, null, -1)
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tên bộ phận:")
], -1)
const _hoisted_8 = { class: "col-3 d-flex align-items-center" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mã bộ phận:")
], -1)
const _hoisted_13 = { class: "col-3 d-flex align-items-center" }
const _hoisted_14 = { class: "mb-0 w-100" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mô tả:")
], -1)
const _hoisted_18 = { class: "col-8 d-flex align-items-center" }
const _hoisted_19 = { class: "mb-0 w-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Địa chỉ:")
], -1)
const _hoisted_23 = { class: "col-8 d-flex align-items-center" }
const _hoisted_24 = { class: "mb-0 w-100" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Đơn vị:")
], -1)
const _hoisted_28 = { class: "col-8 d-flex align-items-center" }
const _hoisted_29 = { class: "mb-0 w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/quan-ly/bo-phan/danh-sach",
          class: "btn btn-primary align-self-center me-2"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: _ctx.updateLinkComputed,
          class: "btn btn-success align-self-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { style: {"font-size":"1.5em"} }, {
              default: _withCtx(() => [
                _createVNode(_component_Edit)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.partDetail.ten_bo_phan,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.partDetail.ten_bo_phan) = $event)),
              readonly: "",
              disabled: "",
              name: "name",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.partDetail.ma_bo_phan,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.partDetail.ma_bo_phan) = $event)),
              name: "code",
              readonly: "",
              disabled: "",
              onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_input, {
              rows: 2,
              type: "textarea",
              modelValue: _ctx.partDetail.mo_ta,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.partDetail.mo_ta) = $event)),
              name: "description",
              readonly: "",
              disabled: "",
              onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_input, {
              rows: 2,
              type: "textarea",
              modelValue: _ctx.partDetail.dia_chi,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.partDetail.dia_chi) = $event)),
              name: "address",
              readonly: "",
              disabled: "",
              onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.departmentName,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.departmentName) = $event)),
              name: "address",
              readonly: "",
              disabled: "",
              onFocus: _cache[9] || (_cache[9] = ($event: any) => ($event.target.select()))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}